// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"610":"d49bdece1e2623db4be3","943":"8e9b81b3765b9d3e4bed"}[chunkId] + ".bundle.js";
};